export default "__VITE_ASSET__DtIsyqp$__"